<template>
    <div class="ad-analysis">
        <OptionCard
                :info="{ title: '广告分析', desc: `${pageParams.startDateTime}~${pageParams.endDateTime}`, label: pageParams.dateLabel}"
                :actions="['refresh']"
                :body-style="{ padding: '0 0 0 20px' }"
                key="ad-analysis"
                @refresh="refresh"
        >
            <OptionCard
                    :info="{ title: '广告分析-气泡图'}"
                    :actions="[]"
                    :areaLevel="2"
                    :body-style="{ paddingBottom: '0' }"
                    noBorder
            >
                <el-row type="flex" style="margin-bottom: 8px">
                    <el-col :span="12" class="flex justify-between align-center">
                        <gj-radio-group style="margin-left: 10px"  v-model="adBubbleType" :options="AD_TYPE_OPTIONS" @change="resetAdTableAnalysis"></gj-radio-group>
                        <i style="margin-right: 5%" class="el-icon-full-screen" @click="showScatter"></i>
                    </el-col>
                </el-row>
                <el-row type="flex" :gutter="10">
                    <el-col :span="12" v-loading="loading.scatter">
                        <div class="ad-analysis-border">
                            <ve-scatter height="300px" :data-empty="chartBubbleData.empty" :legend-visible="false" :data="chartBubbleData.data" :settings="chartBubbleData.settings" :extend="chartBubbleData.options" :set-option-opts="{ notMerge: true, lazyUpdate: true }"></ve-scatter>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div class="ad-analysis-border not_table_border">
                            <gj-table
                                    show-overflow
                                    highlight-hover-row
                                    :index="false"
                                    :loading="pagination.loading"
                                    :data="tableData"
                                    :columns="tableBubbleColumn"
                                    :sort-config="{trigger: 'cell'}"
                                    :adapt-height="false"
                                    :height="300"
                                    @scroll="handleScrollFetchData"
                            >
                                <template v-slot:groupName="{ row }">
                                    <el-row>{{ row.campaignName }} > {{ row.groupName }}</el-row>
                                </template>
                                <template v-slot:clicks="{ row }">
                                    <el-row>{{ row.impressions }}</el-row>
                                    <el-row :class="[row.impressionsCompare < 0 ? 'ad-analysis-down' : 'ad-analysis-up']">{{ row.impressionsCompare | abs }} %</el-row>
                                </template>
                                <template v-slot:ctr="{ row }">
                                    <el-row>{{ row.cvr | abs }} %</el-row>
                                    <el-row :class="[row.cvrCompare < 0 ? 'ad-analysis-down' : 'ad-analysis-up']">{{ row.cvrCompare | abs  }} %</el-row>
                                </template>
                                <template v-slot:acos="{ row }">
                                    <el-row>{{ row.acos | abs  }} %</el-row>
                                    <el-row :class="[row.acosCompare < 0 ? 'ad-analysis-down' : 'ad-analysis-up']">{{ row.acosCompare | abs  }} %</el-row>
                                </template>
                            </gj-table>
                        </div>

                    </el-col>
                </el-row>
            </OptionCard>
            <OptionCard
                    :info="{ title: '广告指标趋势'}"
                    :actions="[]"
                    :areaLevel="2"
                    noBorder
            >
                <el-row type="flex" justify="space-between" style="margin-bottom: 8px">
                    <el-col :span="12">
                        <gj-select
                                v-model="lineForm.campaignIds"
                                type="multi-check"
                                placeholder="全部广告活动"
                                style="width: 180px;"
                                :loading="loading.adOption"
                                :options="adOptionData"
                                @change="() => getAdLineAnalysis()">
                        </gj-select>
                        <gj-select
                                v-model="lineForm.line"
                                :options="AD_LINE_OPTIONS"
                                collapse-tags
                                multiple
                                placeholder="全部广告指标"
                                style="margin-left: 15px; width: 210px;"
                                @change="() => getAdLineAnalysis()"
                        ></gj-select>
                    </el-col>
                    <el-col :span="4" class="flex justify-end">
                        <gj-radio-group
                                v-model="lineForm.type"
                                :options="DATE_OPTIONS"
                                @change="() => getAdLineAnalysis()">

                        </gj-radio-group>
                    </el-col>
                </el-row>
                <el-row v-loading="loading.adLine">
                    <div>
                        <ve-line  height="250px" :data-empty="chartAdLineData.empty" :data="chartAdLineData.data" :settings="chartAdLineData.settings" :extend="chartAdLineData.options"></ve-line>
                    </div>
                </el-row>
               </OptionCard>
                <OptionCard :info="{ title: '用户搜索词分析'}"
                            :actions="[]"
                            :areaLevel="2"
                            noBorder>
                    <gj-button type="ghost" slot="action" @click="handleFilterAdKeywords">过滤常用词</gj-button>
                    <el-row type="flex" :gutter="10">
                        <el-col :span="3" class="flex flex-direction-column align-center" style="min-width: 140px">
                            <gj-select v-model="wordCloud.campaignIds" type="multi-check" :options="adOptionData" @change="postAdWordRanked" style="width: 150px"></gj-select>

                            <div class="flex justify-around flex-direction-column" style="flex: 1">
                                <div class="ad-analysis-search flex flex-direction-column align-center">
                                    <span>用户搜索词总数</span>
                                    <span>{{ wordCloudSearchCount | defaultShow }}</span>
                                </div>
                                <div class="ad-analysis-search flex flex-direction-column align-center">
                                    <span>词云关键词数</span>
                                    <span>{{ wordCloudCount | defaultShow }}</span>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="13">
                            <div class="ad-analysis-image__container">
                                <ve-wordcloud height="299px" :data-empty="wordCloudChartData.empty" :data="wordCloudChartData.data" :settings="wordCloudChartData.settings" :extend="wordCloudChartData.options"></ve-wordcloud>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <gj-table
                                    show-overflow
                                    highlight-hover-row
                                    :height="299"
                                    :index="false"
                                    :data="wordCloudTableData"
                                    :columns="WORD_CLOUD_TABLE_COLUMN"
                                    :sort-config="{trigger: 'cell'}"
                                    :adapt-height="false"
                            >
                            </gj-table>
                        </el-col>
                    </el-row>
                </OptionCard>
        </OptionCard>
    </div>
</template>

<script>
    import {
        DATA_CHARTS,
        DATE_ENUMS,
        AD_TABLE_COLUMN,
        DEFAULT_CHARTS_DATA,
        WORD_CLOUD_TABLE_COLUMN,
        generatorLineChartsData,
        generatorScatterChartsData
    } from "modules/statistics/asin-361-analysis/config";
    import {
        getAdBubbleAnalysis,
        postAdTableAnalysis,
        getAdLineAnalysis,
        postCampaginSelect,
        getAdKeywords,
        postAdKeywords,
        postAdWordRanked
    } from '@/api/statistics'
    import {
        abs
    } from "@/filters";
    import openChartsDialog from "components/option-card/openChartsDialog";
    import {
        AD_TYPE_OPTIONS,
        AD_LINE_OPTIONS,
        DATE_OPTIONS
    } from '@/utils/options'

    import OptionCard from 'components/option-card/option-card'
    import FilterWord from 'components/filter-word/filter-word'

    export default {
        name: "statistics-ad-analysis",
        inject: ['getPageParams', 'generatorPageParams'],
        data () {
          return {
              DATA_CHARTS,
              DATE_ENUMS,
              AD_LINE_OPTIONS,
              AD_TABLE_COLUMN,
              AD_TYPE_OPTIONS,
              WORD_CLOUD_TABLE_COLUMN,
              DATE_OPTIONS: DATE_OPTIONS.filter(v => v.id !== 'HOURS'),
              lineForm: {
                  type: 'DAY',
                  campaignIds: [],
                  line: ['adsOrders', 'cost']
              },
              adLineData: [],
              percentageLine: [],
              unpercentageLine: [],
              amountLine: [],
              adBubbleType: 'adsCampaign',
              bubbleData: [], // 气泡图源数据
              tableData: [],
              pagination: { // 分页
                  current: 1,
                  size: 10,
                  loading: false,
                  more: true // 分页是否可请求
              },
              adOptionData: [], // 广告活动下拉框
              loading: {
                  scatter: false,
                  adOption: false,
                  adLine: false,
                  wordcloud: false
              },
              wordCloud: {
                  campaignIds: []
              },
              wordCloudSearchCount: 0, // 用户搜索词总数
              wordCloudCount: 0, // 词云总数
              wordCloudData: []


          }
        },
        components: {
            OptionCard,
        },
        directives: {
            abs
        },
        created () {
            this.postCampaginSelect()
            this.getAdBubbleAnalysis()
            this.postAdTableAnalysis()
            this.getAdLineAnalysis()
            this.postAdWordRanked()
        },
        computed: {
            pageParams () {
                return this.getPageParams()
            },
            tableBubbleColumn ({ adBubbleType, AD_TABLE_COLUMN }) {
                const activityColumn = [{id: 'campaignName', header: '广告活动', field: 'campaignName', minWidth: '120px'}]
                const groupColumn = [{id: 'groupName', header: '广告组', field: 'slot:groupName', minWidth: '120px'}]
                return adBubbleType === 'adsCampaign' ? activityColumn.concat(AD_TABLE_COLUMN) : groupColumn.concat(AD_TABLE_COLUMN)
            },
            wordCloudChartData ({ wordCloudData = [] }) {
                if(!wordCloudData.length) return DEFAULT_CHARTS_DATA
                const columns = ['word', 'count']
                const rows = wordCloudData.map(({
                    word = '',
                    count = 0
                }) => ({
                    word,
                    count
                }))

                return {
                    data: {
                        rows,
                        columns
                    },
                    settings: {
                        sizeMin: 12,
                        sizeMax: 40
                    },
                    options: {},
                    empty: !rows.length
                }
            },
            chartBubbleData ({ bubbleData = [],  adBubbleType }) {
                if (!bubbleData.length) return DEFAULT_CHARTS_DATA
                let columns = ['CVR', '曝光量', 'ACOS', 'Name']
                let rows = {}
                let maxX = 0
                let maxY = 0
                for (let v of bubbleData) {
                    maxX = maxX < parseFloat(v.cvr) ? parseFloat(v.cvr) : maxX
                    maxY = maxY < parseFloat(v.impressions) ? parseFloat(v.impressions) : maxY
                    rows[`${adBubbleType === 'adsCampaign' ? v.campaignId : v.groupId}`] = [{
                        'CVR': parseFloat(v.cvr),
                        '曝光量': parseFloat(v.impressions),
                        'ACOS': parseFloat(v.acos),
                        'Name': adBubbleType === 'adsCampaign' ? v.campaignName : v.groupName
                    }]
                }
                maxX = Math.ceil(maxX / 4) * 4 // x轴坐标刻度最大值
                maxY = Math.ceil(maxY / 4) * 4 // y轴坐标刻度最大值
                let params = {
                    maxX,
                    maxY,
                    data: [maxX * 0.25, maxX * 0.5, maxX * 0.75, maxX]
                }
                return {
                    data: {
                        columns,
                        rows
                    },
                    settings: {
                        label: {
                            show: true,
                            position: 'top',
                            distance: 5,
                            color: '#7F7F7F',
                            formatter(val) {
                                return `${val.value[3]} ACOS ${val.value[2]}%`
                            }
                        },
                        labelMap: {
                            Name: adBubbleType === 'adsCampaign' ? '广告活动' : '广告组'
                        },
                        yAxisName: ['曝光量'],
                        xAxisName: ['CVR']
                    },
                    options: generatorScatterChartsData(params),
                    empty: !columns.length
                }
            },
            chartAdLineData ({
                 adLineData = [],
                 percentageLine = [],
                 unpercentageLine = [],
                 amountLine = [],
                 lineForm,
                 AD_LINE_OPTIONS
            }) {
                if (!adLineData.length) return DEFAULT_CHARTS_DATA
                let lines = AD_LINE_OPTIONS.filter(({ id }) => lineForm.line.includes(id)).map(({ id }) => id)
                const findItem = str => AD_LINE_OPTIONS.find(({ id }) => id === str)

                let columns = ['date', ...lines]
                let labelMap = {}
                let leftMaxY = 0
                let rightMaxY = 0
                let rows = adLineData.map(v => {
                    let obj = {
                        'date': v.unit
                    }
                    lines.forEach(k => {
                        let item = findItem(k)
                        if (item) {
                            obj[k] = percentageLine.includes(k) ? (parseFloat(v[item['id']]) / 100) : v[item['id']]
                            labelMap[k] = item.text
                            if (percentageLine.includes(k)) {
                                rightMaxY = Math.max(rightMaxY, obj[k])
                            } else {
                                leftMaxY = Math.max(leftMaxY, obj[k])
                            }
                        }

                    })
                    return obj
                })

                let options = generatorLineChartsData()
                options.yAxis = item => {
                    item[0].splitNumber = 5
                    item[0].interval = Math.ceil(leftMaxY / 5)
                    item[0].min = 0
                    item[0].max = Math.ceil(leftMaxY / 5) * 5
                    item[1].splitNumber = 5
                    item[1].interval = rightMaxY > 1 ? Math.ceil((rightMaxY * 100) / 5) / 100 : 1 / 5
                    item[1].min = 0
                    item[1].max = rightMaxY > 1 ? (Math.ceil((rightMaxY * 100) / 5) * 5) / 100 : 1
                    return item
                }
                delete options.tooltip

                return {
                    data: {
                        rows,
                        columns
                    },
                    settings: {
                        labelMap: {
                            date: '日期',
                            ...labelMap
                        },
                        yAxisType: [
                            'normal',
                            'percent'
                        ],
                        axisSite: {
                            right: [
                                ...percentageLine
                            ]
                        }
                    },
                    options,
                    empty: !rows.length
                }
            },
            wordCloudTableData ({ wordCloudData = [] }) {
                return wordCloudData.length <= 20 ? wordCloudData : wordCloudData.slice(0, 20)
            }
        },
        methods: {
            /**
             *
             */
            showLine () {

            },
            /**
             * 气泡图放大
             */
            showScatter () {
                let { data, settings = {}, options: extend } = this.chartBubbleData
                openChartsDialog({
                    instance: 've-scatter',
                    propsData: {
                        data,
                        settings,
                        extend,
                        legendVisible: false,
                        height: '650px'
                    }
                })
            },
            /**
             * 获取词云排行榜
             */
            postAdWordRanked () {
                const model = this.generatorPageParams(this.pageParams)
                model.campaignIds = this.wordCloud.campaignIds
                const params = {
                    ...model
                }
                this.loading.wordcloud = true
                postAdWordRanked(params).then(({ count = 0, searchCount = 0, wordCloudRankList: wordCloudData = []}) => {
                    this.wordCloudCount = count
                    this.wordCloudSearchCount = searchCount
                    this.wordCloudData = wordCloudData || []
                }).complete(() => this.loading.wordcloud = false)
            },
            /**
             * 获取广告分析-气泡
             */
            getAdBubbleAnalysis () {
                let params = this.generatorPageParams(this.pageParams)
                params.type = this.adBubbleType
                this.loading.scatter = true
                getAdBubbleAnalysis(params).then(res => {
                    this.bubbleData = res || []
                }).complete(() => {
                    this.loading.scatter = false
                })
            },
            /**
             * 重置请求
             */
            resetAdTableAnalysis () {
                this.pagination.current = 1
                this.pagination.more = true
                this.pagination.loading = false
                this.getAdBubbleAnalysis()
                this.postAdTableAnalysis()
            },
            /**
             * 获取广告分析-表格
             */
            postAdTableAnalysis () {
                if (!this.pagination.more || this.pagination.loading) return

                this.pagination.loading = true
                let model = this.generatorPageParams(this.pageParams)
                model.type = this.adBubbleType

                let params = {
                    model,
                    ...this.pagination
                }

                postAdTableAnalysis(params).then(({ records = [], total = 0 }) => {
                    if (!records.length) this.pagination.more = false
                    if (this.pagination.current === 1) {
                        this.tableData = records
                    } else {
                        this.tableData.push(...records)
                    }
                    this.tableData = this.tableData.map(({
                         campaignId = '',
                         campaignName = '',
                         groupName = '',
                         groupId = '',
                         clicks = 0,
                         clicksCompare = 0,
                         ctr = 0,
                         ctrCompare = 0,
                         acos = 0,
                         acosCompare = 0,
                         impressions = 0,
                         impressionsCompare = 0,
                         cvr = 0,
                         cvrCompare = 0

                     }) => ({
                        campaignId,
                        campaignName,
                        groupName,
                        groupId,
                        clicks: clicks ? parseFloat(clicks) : 0,
                        clicksCompare: clicksCompare ? parseFloat(clicksCompare) : 0,
                        ctr: ctr ? parseFloat(ctr) : 0,
                        ctrCompare: ctrCompare ? parseFloat(ctrCompare) : 0,
                        acos: acos ? parseFloat(acos) : 0,
                        acosCompare: acosCompare ? parseFloat(acosCompare) : 0,
                        impressions: impressions ? parseFloat(impressions) : 0,
                        impressionsCompare: impressionsCompare ? parseFloat(impressionsCompare) : 0,
                        cvr: cvr ? parseFloat(cvr) : 0,
                        cvrCompare: cvrCompare ? parseFloat(cvrCompare) : 0,
                    }))

                    this.pagination.current++
                    this.pagination.more = total > this.tableData.length
                    this.pagination.loading = false
                }).catch(() => {
                    this.pagination.loading = false
                    this.pagination.more = false
                })
            },
            /**
             * 获取指标趋势折线数据
             */
            getAdLineAnalysis () {
                let pageParams = this.generatorPageParams(this.pageParams)
                let params = {
                    ...pageParams,
                    ...this.lineForm
                }

                if (!params.line.length) return false
                this.loading.adLine = true
                getAdLineAnalysis(params).then(({ statisticsData = [], percentageLine = [],  unpercentageLine = [], amountLine = [] }) => {
                    this.adLineData = statisticsData
                    this.percentageLine = percentageLine
                    this.unpercentageLine = unpercentageLine
                    this.amountLine = amountLine
                }).complete(() => {
                    this.loading.adLine = false
                })
            },
            /**
             * 分页请求
             */
            handleScrollFetchData ({ type, scrollTop, scrollLeft, isX, isY, $event }) {
                let scrollHeight = $event.target.scrollHeight
                let clientHeight = $event.target.clientHeight
                if (scrollTop + clientHeight >= scrollHeight - 100) {
                    this.postAdTableAnalysis()
                }
            },
            /**
             * 过滤常用词弹窗
             */
            handleFilterAdKeywords () {
                const params = this.generatorPageParams(this.pageParams)
                const fnView = getAdKeywords.bind(null, params)
                const fnUpdate = postAdKeywords
                const modal = this.$gjCreate(FilterWord, {
                    props: {
                        fnView,
                        fnUpdate
                    },
                    on: {
                        complete: () => {
                            this.postAdWordRanked()
                        }
                    }
                })
            },
            /**
             * 获取广告活动下拉选项
             */
            postCampaginSelect () {
                let params = this.generatorPageParams(this.pageParams)
                this.loading.adOption = true
                postCampaginSelect(params).then((res = []) => {
                    this.adOptionData = res.map(({ campaignId: id, campaignName: text }) => ({ id, text }))
                    this.loading.adOption = false
                }).catch(() => {
                    this.loading.adOption = false
                })
            },
            /**
             * 刷新区域数据
             */
            refresh () {
                this.postCampaginSelect()
                this.getAdBubbleAnalysis()
                this.resetAdTableAnalysis()
                this.getAdLineAnalysis()
                this.postAdWordRanked()
            }
        }
    }
</script>

<style lang="scss" scoped>
    .not_table_border{
        /deep/ .vxe-table--border-line{
            border: none;
        }
    }
    .ad-analysis {

        &-margin {
            margin: 15px 0;
        }

        &-border {
            border-radius: 4px;
            border: 1px solid #EBEEF5;
            overflow: hidden;
        }

        &-down {
            color: #F97878;
        }

        &-up {
            color: #31E26C;
        }

        &-search {
            color: #666666;
            font-weight: bold;

            > span {
                flex: 1;
            }

            > span:nth-child(1) {
               font-size: 16px;
                margin-bottom: 10px;
            }

            > span:nth-child(2) {
                font-size: 22px;
            }
        }

        &-image {
            &__container {
                height: 299px;

                & > img {
                    object-fit: cover;
                    object-position: center;
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
</style>
